var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md"},[('body' in _vm.news)?[(_vm.news.body)?_c('div',{staticClass:"m-0 p-3",domProps:{"innerHTML":_vm._s(_vm.news.body)}}):_vm._e()]:_vm._e()],2)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d006ef3","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/news-list-details.vue
// module id = null
// module chunks = 